export default {"src":"/_next/static/media/pimento.68b5f768.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};